/* globals XmlElement */
function LogEntry (recordType, functionName, functionArgs) {
    this.timeStamp = new Date();
    this.attributes = {};
    this.children = [];
    this.returnValue = null;
    this.text = null;

    this.recordType = recordType;
    this.functionName = functionName;
    this.functionArgs = functionArgs;
}

LogEntry.prototype = {
    write: function (message) {
        var msgEntry = new LogEntry("i", null, null);

        msgEntry.text = message;

        this.appendChild(msgEntry);
    },

    error: function (message) {
        var msgEntry = new LogEntry("e", null, null);

        msgEntry.text = message;

        this.appendChild(msgEntry);
    },

    startNew: function (recordType, args, data) {
        var logEntry,
            functionName;

        if (typeof args === "string") {
            logEntry = new LogEntry(recordType, args, data);
        }
        else if (args !== null && typeof args !== "undefined") {
            functionName = args.callee.toString().substring(9, args.callee.toString().indexOf("{") - 1);

            logEntry = new LogEntry(recordType, functionName, args);
        }
        else {
            logEntry = new LogEntry(recordType, "unknown entry point");
        }

        this.appendChild(logEntry);

        return logEntry;
    },

    setAttribute: function (name, value) {
        this.attributes[name] = value;
    },

    setReturn: function (value) {
        this.returnValue = {
            value: value,
            elapsedTime: (new Date().getTime() - this.timeStamp.getTime()) / 1000
        };
    },

    appendChild: function (child) {
        this.children.push(child);
    },

    formatTimestampForLog: function (utc) {
        var hours,
            minutes,
            seconds,
            milliseconds;

        if (utc) {
            hours = this.timeStamp.getUTCHours();
            minutes = this.timeStamp.getUTCMinutes();
            seconds = this.timeStamp.getUTCSeconds();
            milliseconds = this.timeStamp.getUTCMilliseconds();
        }
        else {
            hours = this.timeStamp.getHours();
            minutes = this.timeStamp.getMinutes();
            seconds = this.timeStamp.getSeconds();
            milliseconds = this.timeStamp.getMilliseconds();
        }

        return hours.toString().leftpad("0", 2) + ":" + minutes.toString().leftpad("0", 2) + ":" + seconds.toString().leftpad("0", 2) + "." + milliseconds.toString().leftpad("0", 3);
    },

    xmlEscapeText: function () {
        var str = this.text;

        if (str === null) {
            return "null";
        }

        // eslint-disable-next-line new-cap
        return XmlElement.Encode(str);
    }
};
